export default "__VITE_ASSET__D3KqME4p__"